import React from 'react';
import Modal from '../Modal';
import './DeletedGitTestCasesModal.sass';

const DeletedGitTestCasesModal = ({
  onClose = () => { },
  onContinue = () => { },
  deletedTestCases = [],
  loading = false,
}) => {
  return (
    <Modal
      title="Test Cases Deleted from Git Source"
      onClose={onClose}
      size="lg"
    >
      <div className="deleted-git-testcases-modal">
        <div className="alert alert-info">
          <strong>ℹ️ Git Source Changes Detected</strong>
          <p className="mb-0">
            The following {deletedTestCases.length} test case(s) were previously imported from Git 
            but are no longer present in the source repository. These test cases will be automatically 
            marked as invalid.
          </p>
        </div>

        <div className="deleted-list">
          <h6>Test Cases Being Marked as Invalid:</h6>
          <ul className="list-group">
            {deletedTestCases.map((tc, index) => (
              <li key={index} className="list-group-item">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <strong>{tc.displayname || tc.testcasename || tc.description}</strong>
                    <br />
                    <small className="text-muted">
                      <code>{tc.file_path || tc.spec || tc.testcasedir}</code>
                      {tc.grep && <span className="ml-2">Grep: <code>{tc.grep}</code></span>}
                    </small>
                  </div>
                  <span className="badge badge-danger">Deleted from Git</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="info-note mt-3">
          <small className="text-muted">
            <i className="bi bi-info-circle"></i> These test cases will be marked with a "⚠️ Deleted from Git" badge 
            and can be identified on the main page.
          </small>
        </div>

        <div className="action-buttons mt-4">
          <button
            className="btn btn-primary"
            onClick={onContinue}
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Continue with Import'}
          </button>
          <button
            className="btn btn-secondary ml-2"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeletedGitTestCasesModal;

